// extracted by mini-css-extract-plugin
module.exports = {"AskHeader":"AskHeader_AskHeader__38nyU"};